interface BookUniViniIconProps {
	size?: number
}

export function MagicPenIcon({ size = 20 }: BookUniViniIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
		>
			<path
				d="M16.2495 6.25007L15.0078 7.49173L12.5078 4.99173L13.7495 3.75007C14.0995 3.40007 14.5495 3.2334 14.9995 3.2334C15.4495 3.2334 15.8995 3.40007 16.2495 3.75007C16.9411 4.44173 16.9411 5.5584 16.2495 6.25007Z"
				fill="currentColor"
			/>
			<path
				d="M14.4255 8.08301L5.41719 17.083C4.72552 17.7747 3.60885 17.7747 2.91719 17.083C2.22552 16.3913 2.22552 15.2747 2.91719 14.583L11.9255 5.58301L14.4255 8.08301Z"
				fill="currentColor"
			/>
			<path
				d="M8.29079 2.91644L8.63245 1.7581C8.66579 1.64977 8.63245 1.5331 8.55745 1.44977C8.48245 1.36644 8.34912 1.3331 8.24079 1.36644L7.08245 1.7081L5.92412 1.36644C5.81579 1.3331 5.69912 1.36644 5.61579 1.44144C5.53245 1.52477 5.50745 1.64144 5.54079 1.74977L5.87412 2.91644L5.53245 4.07477C5.49912 4.1831 5.53245 4.29977 5.60745 4.3831C5.69079 4.46644 5.80745 4.49144 5.91579 4.4581L7.08245 4.12477L8.24079 4.46644C8.27412 4.47477 8.29912 4.4831 8.33245 4.4831C8.41579 4.4831 8.49079 4.44977 8.55745 4.39144C8.64079 4.3081 8.66579 4.19144 8.63245 4.0831L8.29079 2.91644Z"
				fill="currentColor"
			/>
			<path
				d="M4.95875 7.91644L5.30042 6.7581C5.33375 6.64977 5.30042 6.5331 5.22542 6.44977C5.14209 6.36644 5.02542 6.34144 4.91709 6.37477L3.75042 6.7081L2.59209 6.36644C2.48375 6.3331 2.36709 6.36644 2.28375 6.44144C2.20042 6.52477 2.17542 6.64144 2.20875 6.74977L2.54209 7.91644L2.20042 9.07477C2.16709 9.1831 2.20042 9.29977 2.27542 9.3831C2.35875 9.46644 2.47542 9.49144 2.58375 9.4581L3.74209 9.11644L4.90042 9.4581C4.92542 9.46644 4.95875 9.46644 4.99209 9.46644C5.07542 9.46644 5.15042 9.4331 5.21709 9.37477C5.30042 9.29144 5.32542 9.17477 5.29209 9.06644L4.95875 7.91644Z"
				fill="currentColor"
			/>
			<path
				d="M17.4591 12.0833L17.8007 10.925C17.8341 10.8166 17.8007 10.7 17.7257 10.6166C17.6424 10.5333 17.5257 10.5083 17.4174 10.5416L16.2591 10.8833L15.1007 10.5416C14.9924 10.5083 14.8757 10.5416 14.7924 10.6166C14.7091 10.7 14.6841 10.8166 14.7174 10.925L15.0591 12.0833L14.7174 13.2416C14.6841 13.35 14.7174 13.4666 14.7924 13.55C14.8757 13.6333 14.9924 13.6583 15.1007 13.625L16.2591 13.2833L17.4174 13.625C17.4424 13.6333 17.4757 13.6333 17.5091 13.6333C17.5924 13.6333 17.6674 13.6 17.7341 13.5416C17.8174 13.4583 17.8424 13.3416 17.8091 13.2333L17.4591 12.0833Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export function CloseFullIcon({ size = 20 }: BookUniViniIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.41093 4.41152C4.73636 4.08608 5.264 4.08608 5.58944 4.41152L15.5894 14.4115C15.9149 14.737 15.9149 15.2646 15.5894 15.59C15.264 15.9155 14.7364 15.9155 14.4109 15.59L4.41093 5.59003C4.08549 5.2646 4.08549 4.73696 4.41093 4.41152Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.5894 4.41152C15.9149 4.73696 15.9149 5.2646 15.5894 5.59003L5.58944 15.59C5.264 15.9155 4.73636 15.9155 4.41093 15.59C4.08549 15.2646 4.08549 14.737 4.41093 14.4115L14.4109 4.41152C14.7364 4.08608 15.264 4.08608 15.5894 4.41152Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export function DocumentDownloadIcon({ size = 20 }: BookUniViniIconProps) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden
		>
			<path
				d="M17.084 8.49199H14.6757C12.7007 8.49199 11.0923 6.88366 11.0923 4.90866V2.50033C11.0923 2.04199 10.7173 1.66699 10.259 1.66699H6.72565C4.15898 1.66699 2.08398 3.33366 2.08398 6.30866V13.692C2.08398 16.667 4.15898 18.3337 6.72565 18.3337H13.2757C15.8423 18.3337 17.9173 16.667 17.9173 13.692V9.32533C17.9173 8.86699 17.5423 8.49199 17.084 8.49199ZM10.234 13.1503L8.56732 14.817C8.50898 14.8753 8.43398 14.9253 8.35898 14.9503C8.28398 14.9837 8.20898 15.0003 8.12565 15.0003C8.04232 15.0003 7.96732 14.9837 7.89232 14.9503C7.82565 14.9253 7.75898 14.8753 7.70898 14.8253C7.70065 14.817 7.69232 14.817 7.69232 14.8087L6.02565 13.142C5.78398 12.9003 5.78398 12.5003 6.02565 12.2587C6.26732 12.017 6.66732 12.017 6.90898 12.2587L7.50065 12.867V9.37533C7.50065 9.03366 7.78398 8.75033 8.12565 8.75033C8.46732 8.75033 8.75065 9.03366 8.75065 9.37533V12.867L9.35065 12.267C9.59232 12.0253 9.99232 12.0253 10.234 12.267C10.4757 12.5087 10.4757 12.9087 10.234 13.1503Z"
				fill="currentColor"
			/>
			<path
				d="M14.5257 7.34199C15.3173 7.35033 16.4173 7.35033 17.359 7.35033C17.834 7.35033 18.084 6.79199 17.7507 6.45866C16.5506 5.25033 14.4007 3.07533 13.1673 1.84199C12.8257 1.50033 12.234 1.73366 12.234 2.20866V5.11699C12.234 6.33366 13.2673 7.34199 14.5257 7.34199Z"
				fill="currentColor"
			/>
		</svg>
	)
}

export const BOOK_UNIVINI_ICON_SECONDARY = '#7987A4'

export const BOOK_UNIVINI_ICON_MUTED = '#94A3B8'

export const BOOK_UNIVINI_ICON_BRAND = '#1f7a44'
